export enum EWsStatus {
  CONNECTED = 'CONNECTED',
  RECEIVED = 'RECEIVED',
  INITIALIZE = 'INITIALIZE',
  LOAD_CONVERSATION = 'LOAD_CONVERSATION',
  NEW_CONNECTION = 'NEW_CONNECTION',
  NEW_MESSAGE = 'NEW_MESSAGE',
  READ_MESSAGE = 'MESSAGE_READ',
  STORED = 'STORED'
}
